import { createContext } from "react";
import { Entity, ParamsApi } from "../../models";
import { Any } from "../../test-helpers/Any";

export type IQueryParamsContext = {
    getParamsApi: (entity: Entity) => ParamsApi;
};

export const defaultQueryParamsContext: IQueryParamsContext = {
    getParamsApi: () => Any.object<ParamsApi>(),
};

export const QueryParamsContext = createContext(defaultQueryParamsContext);
QueryParamsContext.displayName = "QueryParams";
